/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CourtProceeding,
  Event,
  HTTPValidationError,
  Party,
  Prosecution,
  ProsecutionCreate,
  ProsecutionUpdate,
  RelatedCase,
  Violation,
} from '../models/index';
import {
    CourtProceedingFromJSON,
    CourtProceedingToJSON,
    EventFromJSON,
    EventToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PartyFromJSON,
    PartyToJSON,
    ProsecutionFromJSON,
    ProsecutionToJSON,
    ProsecutionCreateFromJSON,
    ProsecutionCreateToJSON,
    ProsecutionUpdateFromJSON,
    ProsecutionUpdateToJSON,
    RelatedCaseFromJSON,
    RelatedCaseToJSON,
    ViolationFromJSON,
    ViolationToJSON,
} from '../models/index';

export interface CreateProsecutionApiV1ProsecutionsPostRequest {
    prosecutionCreate: ProsecutionCreate;
}

export interface CreateProsecutionApiV1ProsecutionsPost0Request {
    prosecutionCreate: ProsecutionCreate;
}

export interface DeleteProsecutionApiV1ProsecutionsIdDeleteRequest {
    id: number;
}

export interface ReadProsecutionByIdApiV1ProsecutionsIdGetRequest {
    id: number;
}

export interface ReadProsecutionCourtProceedingsApiV1ProsecutionsIdCourtProceedingsGetRequest {
    id: number;
}

export interface ReadProsecutionEventsApiV1ProsecutionsIdEventsGetRequest {
    id: number;
}

export interface ReadProsecutionPartiesApiV1ProsecutionsIdPartiesGetRequest {
    id: number;
}

export interface ReadProsecutionRelatedCasesApiV1ProsecutionsIdRelatedCasesGetRequest {
    id: number;
}

export interface ReadProsecutionViolationsApiV1ProsecutionsIdViolationsGetRequest {
    id: number;
}

export interface ReadProsecutionsApiV1ProsecutionsGetRequest {
    skip?: number;
    limit?: number;
}

export interface ReadProsecutionsApiV1ProsecutionsGet0Request {
    skip?: number;
    limit?: number;
}

export interface UpdateProsecutionApiV1ProsecutionsIdPutRequest {
    id: number;
    prosecutionUpdate: ProsecutionUpdate;
}

/**
 * 
 */
export class ProsecutionsApi extends runtime.BaseAPI {

    /**
     * Create new prosecution.
     * Create Prosecution
     */
    async createProsecutionApiV1ProsecutionsPostRaw(requestParameters: CreateProsecutionApiV1ProsecutionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Prosecution>> {
        if (requestParameters['prosecutionCreate'] == null) {
            throw new runtime.RequiredError(
                'prosecutionCreate',
                'Required parameter "prosecutionCreate" was null or undefined when calling createProsecutionApiV1ProsecutionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecutions/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProsecutionCreateToJSON(requestParameters['prosecutionCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionFromJSON(jsonValue));
    }

    /**
     * Create new prosecution.
     * Create Prosecution
     */
    async createProsecutionApiV1ProsecutionsPost(requestParameters: CreateProsecutionApiV1ProsecutionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Prosecution> {
        const response = await this.createProsecutionApiV1ProsecutionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new prosecution.
     * Create Prosecution
     */
    async createProsecutionApiV1ProsecutionsPost_1Raw(requestParameters: CreateProsecutionApiV1ProsecutionsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Prosecution>> {
        if (requestParameters['prosecutionCreate'] == null) {
            throw new runtime.RequiredError(
                'prosecutionCreate',
                'Required parameter "prosecutionCreate" was null or undefined when calling createProsecutionApiV1ProsecutionsPost_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecutions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProsecutionCreateToJSON(requestParameters['prosecutionCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionFromJSON(jsonValue));
    }

    /**
     * Create new prosecution.
     * Create Prosecution
     */
    async createProsecutionApiV1ProsecutionsPost_1(requestParameters: CreateProsecutionApiV1ProsecutionsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Prosecution> {
        const response = await this.createProsecutionApiV1ProsecutionsPost_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a prosecution.
     * Delete Prosecution
     */
    async deleteProsecutionApiV1ProsecutionsIdDeleteRaw(requestParameters: DeleteProsecutionApiV1ProsecutionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Prosecution>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteProsecutionApiV1ProsecutionsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecutions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionFromJSON(jsonValue));
    }

    /**
     * Delete a prosecution.
     * Delete Prosecution
     */
    async deleteProsecutionApiV1ProsecutionsIdDelete(requestParameters: DeleteProsecutionApiV1ProsecutionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Prosecution> {
        const response = await this.deleteProsecutionApiV1ProsecutionsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific prosecution by id.
     * Read Prosecution By Id
     */
    async readProsecutionByIdApiV1ProsecutionsIdGetRaw(requestParameters: ReadProsecutionByIdApiV1ProsecutionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Prosecution>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readProsecutionByIdApiV1ProsecutionsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecutions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionFromJSON(jsonValue));
    }

    /**
     * Get a specific prosecution by id.
     * Read Prosecution By Id
     */
    async readProsecutionByIdApiV1ProsecutionsIdGet(requestParameters: ReadProsecutionByIdApiV1ProsecutionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Prosecution> {
        const response = await this.readProsecutionByIdApiV1ProsecutionsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get court proceedings for a specific prosecution.
     * Read Prosecution Court Proceedings
     */
    async readProsecutionCourtProceedingsApiV1ProsecutionsIdCourtProceedingsGetRaw(requestParameters: ReadProsecutionCourtProceedingsApiV1ProsecutionsIdCourtProceedingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourtProceeding>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readProsecutionCourtProceedingsApiV1ProsecutionsIdCourtProceedingsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecutions/{id}/court-proceedings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourtProceedingFromJSON));
    }

    /**
     * Get court proceedings for a specific prosecution.
     * Read Prosecution Court Proceedings
     */
    async readProsecutionCourtProceedingsApiV1ProsecutionsIdCourtProceedingsGet(requestParameters: ReadProsecutionCourtProceedingsApiV1ProsecutionsIdCourtProceedingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourtProceeding>> {
        const response = await this.readProsecutionCourtProceedingsApiV1ProsecutionsIdCourtProceedingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all events for a specific prosecution.
     * Read Prosecution Events
     */
    async readProsecutionEventsApiV1ProsecutionsIdEventsGetRaw(requestParameters: ReadProsecutionEventsApiV1ProsecutionsIdEventsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Event>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readProsecutionEventsApiV1ProsecutionsIdEventsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/prosecutions/{id}/events`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventFromJSON));
    }

    /**
     * Get all events for a specific prosecution.
     * Read Prosecution Events
     */
    async readProsecutionEventsApiV1ProsecutionsIdEventsGet(requestParameters: ReadProsecutionEventsApiV1ProsecutionsIdEventsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Event>> {
        const response = await this.readProsecutionEventsApiV1ProsecutionsIdEventsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all parties for a specific prosecution.
     * Read Prosecution Parties
     */
    async readProsecutionPartiesApiV1ProsecutionsIdPartiesGetRaw(requestParameters: ReadProsecutionPartiesApiV1ProsecutionsIdPartiesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Party>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readProsecutionPartiesApiV1ProsecutionsIdPartiesGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/prosecutions/{id}/parties`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartyFromJSON));
    }

    /**
     * Get all parties for a specific prosecution.
     * Read Prosecution Parties
     */
    async readProsecutionPartiesApiV1ProsecutionsIdPartiesGet(requestParameters: ReadProsecutionPartiesApiV1ProsecutionsIdPartiesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Party>> {
        const response = await this.readProsecutionPartiesApiV1ProsecutionsIdPartiesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all related cases for a specific prosecution.
     * Read Prosecution Related Cases
     */
    async readProsecutionRelatedCasesApiV1ProsecutionsIdRelatedCasesGetRaw(requestParameters: ReadProsecutionRelatedCasesApiV1ProsecutionsIdRelatedCasesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RelatedCase>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readProsecutionRelatedCasesApiV1ProsecutionsIdRelatedCasesGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/prosecutions/{id}/related-cases`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RelatedCaseFromJSON));
    }

    /**
     * Get all related cases for a specific prosecution.
     * Read Prosecution Related Cases
     */
    async readProsecutionRelatedCasesApiV1ProsecutionsIdRelatedCasesGet(requestParameters: ReadProsecutionRelatedCasesApiV1ProsecutionsIdRelatedCasesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RelatedCase>> {
        const response = await this.readProsecutionRelatedCasesApiV1ProsecutionsIdRelatedCasesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all violations for a specific prosecution.
     * Read Prosecution Violations
     */
    async readProsecutionViolationsApiV1ProsecutionsIdViolationsGetRaw(requestParameters: ReadProsecutionViolationsApiV1ProsecutionsIdViolationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Violation>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readProsecutionViolationsApiV1ProsecutionsIdViolationsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/prosecutions/{id}/violations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ViolationFromJSON));
    }

    /**
     * Get all violations for a specific prosecution.
     * Read Prosecution Violations
     */
    async readProsecutionViolationsApiV1ProsecutionsIdViolationsGet(requestParameters: ReadProsecutionViolationsApiV1ProsecutionsIdViolationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Violation>> {
        const response = await this.readProsecutionViolationsApiV1ProsecutionsIdViolationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve prosecutions.
     * Read Prosecutions
     */
    async readProsecutionsApiV1ProsecutionsGetRaw(requestParameters: ReadProsecutionsApiV1ProsecutionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Prosecution>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecutions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProsecutionFromJSON));
    }

    /**
     * Retrieve prosecutions.
     * Read Prosecutions
     */
    async readProsecutionsApiV1ProsecutionsGet(requestParameters: ReadProsecutionsApiV1ProsecutionsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Prosecution>> {
        const response = await this.readProsecutionsApiV1ProsecutionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve prosecutions.
     * Read Prosecutions
     */
    async readProsecutionsApiV1ProsecutionsGet_2Raw(requestParameters: ReadProsecutionsApiV1ProsecutionsGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Prosecution>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecutions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProsecutionFromJSON));
    }

    /**
     * Retrieve prosecutions.
     * Read Prosecutions
     */
    async readProsecutionsApiV1ProsecutionsGet_2(requestParameters: ReadProsecutionsApiV1ProsecutionsGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Prosecution>> {
        const response = await this.readProsecutionsApiV1ProsecutionsGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a prosecution.
     * Update Prosecution
     */
    async updateProsecutionApiV1ProsecutionsIdPutRaw(requestParameters: UpdateProsecutionApiV1ProsecutionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Prosecution>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProsecutionApiV1ProsecutionsIdPut().'
            );
        }

        if (requestParameters['prosecutionUpdate'] == null) {
            throw new runtime.RequiredError(
                'prosecutionUpdate',
                'Required parameter "prosecutionUpdate" was null or undefined when calling updateProsecutionApiV1ProsecutionsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecutions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProsecutionUpdateToJSON(requestParameters['prosecutionUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionFromJSON(jsonValue));
    }

    /**
     * Update a prosecution.
     * Update Prosecution
     */
    async updateProsecutionApiV1ProsecutionsIdPut(requestParameters: UpdateProsecutionApiV1ProsecutionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Prosecution> {
        const response = await this.updateProsecutionApiV1ProsecutionsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
